import React, { memo } from "react";
import { withRedux, WithReduxHocPropsType } from "@al/next/al-ex";

import CommonHeader from "~/components/ui/CommonHeader";

import { SkuInfoType, SkuPriceType, ProductDetailType } from "../../types";

import styles from "./styles.scss";

interface Props extends WithReduxHocPropsType {
  detail: ProductDetailType;
  skuPrice: SkuPriceType;
  currentSku: SkuInfoType;
}

const Header: React.FC<Props> = (props) => {
  const { detail } = props;
  if (!detail) return null;

  return <CommonHeader className={styles.header} />;
};

export default withRedux((state) => ({
  currentSku: state.static.currentSku,
  skuPrice: state.static.skuPrice,
}))(memo(Header));
